import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TabCloseEvent, TabStripComponent } from '@progress/kendo-angular-layout';
import { FlowEventService, FlowEvent } from '../services/flow-event.service';
import { Subscription } from 'rxjs';
import { TabContentLoadOnDemandDirective } from './loadOnDemand.directive'
import { environment } from '../../environments/environment';
import { StorageRouterService } from '../services/storage-router.service';
import { Settings } from '../flows/settings';

@Component({
    selector: 'app-route-root',
    templateUrl: './route-root.component.html',
    styleUrls: ['./route-root.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class RouteRootComponent implements OnInit, OnDestroy {

    private selectionTimeoutId: ReturnType<typeof setTimeout> | null = null;
    public toggleExpandIcon = '/assets/icons/chevron_right_20_regular.svg';
    public toggleCollapseIcon = '/assets/icons/chevron_left_20_regular.svg';

    constructor(
        private router: Router,
        private flowEventService: FlowEventService,
        private route: ActivatedRoute,
        private storageDexieService: StorageRouterService
        ) {

        this.selectedId = this.router.url;

        this.router.events.subscribe((event)=>{
            //console.log(event);
            if (event instanceof NavigationEnd) {
                const nav_item = this.findBestNavMatch(event.urlAfterRedirects);

                if (nav_item) {
                    //console.log(nav_item);
                    nav_item.selected = true;
                }
            }
        })
    
    }

    nav: any[] = [
        {
            text: '',
            iconClass: 'ms-Icon ms-Icon--GlobalNavButton',
            root: true            
        },
        {
            text: 'Flows',
            url: '/flows',
            path: '/flows',
            // nav_icon: 'track-changes-accept',
            iconClass: 'ms-Icon ms-Icon--MicrosoftFlowLogo',
            ms_icon: 'ms-Icon--MicrosoftFlowLogo',
            // disabled: true,
        },
        {
            text: 'Clipboard',
            url: '/clipboard',
            path: '/clipboard',
            // nav_icon: 'paste',
            iconClass: 'ms-Icon ms-Icon--PasteAsCode',
            ms_icon: 'ms-Icon--PasteAsCode',
            // disabled: true,
            subscription: false
        },

        // {
        //     text: 'Flows (Solutions)',
        //     url: '/solutions',
        //     // nav_icon: 'track-changes-accept-all',
        //     ms_icon: 'ms-Icon--CommonDataServiceCDS',
        //     disabled: true,
        //     subscription: true
        // },
        // {
        //     text: 'Flows (Admin/Old)',
        //     url: '/admin-old',
        //     // nav_icon: 'track-changes-accept-all',
        //     ms_icon: 'ms-Icon--Admin',
        //     disabled: true,
        //     subscription: true
        // },
        // {
        //     text: 'Dashboards',
        //     url: '/dashboards',
        //     nav_icon: 'ungroup',
        //     disabled: true,
        //     subscription: true
        // },
        {
            text: 'PowerApps',
            url: '/powerapps',
            path: '/powerapps',
            // nav_icon: 'search',
            iconClass: 'ms-Icon ms-Icon--PowerAppsLogo',
            ms_icon: 'ms-Icon--PowerAppsLogo',
            //disabled: true,
            subscription: false
        },
        {
            text: 'Admin Flows',
            url: '/admin',
            path: '/admin',
            // nav_icon: 'track-changes-accept-all',
            iconClass: 'ms-Icon ms-Icon--Admin',
            ms_icon: 'ms-Icon--Admin',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        {
            text: 'Search',
            url: '/search',
            path: '/search',
            // nav_icon: 'search',
            iconClass: 'ms-Icon ms-Icon--Search',
            ms_icon: 'ms-Icon--Search',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        {
            text: 'Migrate Flows',
            url: '/migrate',
            path: '/migrate',
            // nav_icon: 'arrow-60-right',
            iconSrc: '/assets/icons/arrow_flow_up_right_rectangle_multiple_20_regular.svg',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        // {
        //     text: 'By Actions',
        //     url: '/flows/actions',
        //     ms_icon: 'ms-Icon--GroupedList',
        //     disabled: true,
        //     subscription: true
        // },
        {
            text: 'Compare Flows',
            url: '/diff',
            path: '/diff',
            // nav_icon: 'paste',
            iconClass: 'ms-Icon ms-Icon--DiffSideBySide',
            ms_icon: 'ms-Icon--DiffSideBySide',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        {
            text: 'Export Flows',
            url: '/zip',
            path: '/zip',
            // nav_icon: 'paste',
            iconClass: 'ms-Icon ms-Icon--ZipFolder',
            ms_icon: 'ms-Icon--ZipFolder',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        {
            text: 'Approvals',
            url: '/approvals',
            path: '/approvals',
            // nav_icon: 'checkbox-checked',
            iconClass: 'ms-Icon ms-Icon--WorkItem',
            ms_icon: 'ms-Icon--WorkItem',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        {
            text: 'Connections',
            url: '/connections',
            path: '/connections',
            // nav_icon: 'file-ascx',
            iconClass: 'ms-Icon ms-Icon--PlugDisconnected',
            ms_icon: 'ms-Icon--PlugDisconnected',
            // disabled: true,
            subscription: true,
            cssClass: 'pro-box'
        },
        {
            text: 'HTTP Request',
            url: '/flows/request',
            path: '/flows/request',
            iconClass: 'ms-Icon ms-Icon--MicrosoftFlowLogo',
            ms_icon: 'ms-Icon--MicrosoftFlowLogo',
            // nav_icon: 'saturation',
            subscription: true,
            cssClass: 'pro-box',
            // disabled: true
            hidden: false
        },
        {
            text: 'Child Flows',
            url: '/flows/child-flows',
            path: '/flows/child-flows',
            iconClass: 'ms-Icon ms-Icon--BranchFork2',
            ms_icon: 'ms-Icon--BranchFork2',
            subscription: true,
            cssClass: 'pro-box',
            hidden: false
        },
        {
            text: 'Workspace',
            url: '/teams',
            path: '/teams',
            iconSrc: '/assets/icons/data_usage_checkmark_20_regular.svg',
            team: true,
            matchPrefix: true,
            cssClass: 'team-box'
        },
        // {
        //     text: 'Flows (Request)',
        //     url: '/teams/request',
        //     path: '/teams/request',
        //     iconClass: 'ms-Icon ms-Icon--MetricsUsage',
        //     ms_icon: 'ms-Icon--MetricsUsage',
        //     // nav_icon: 'saturation',
        //     team: true,
        //     cssClass: 'team-box'
        //     // disabled: true
        // },

        {
            separator: true,
        },        
        {
            text: 'Settings',
            url: '/settings',
            path: '/settings',
            iconClass: 'ms-Icon ms-Icon--Settings',
            ms_icon: 'ms-Icon--Settings',
            // nav_icon: 'saturation',
            // disabled: true
            cssClass: 'settings-item'
        },
        /*,
        {
            text: 'About',
            url: '/welcome',
            // nav_icon: 'information',
            ms_icon: 'ms-Icon--Info',
            disabled: true
        }*/
    ];
    selectedId = '';
    public expanded = false;
    public sidebarDiscoverExpanded = true;
    public sidebarBuildExpanded = true;

    tabs: {
      title: string,
        type: string,
        item: any,
        id: number,
        value: any  
    }[] = [
        // {
        //     title: 'Tab 1'
        // },
        // {
        //     title: 'Tab 2'
        // },
    ]

    subscriptions = [];
    selectedTabIndex = 0;

    @ViewChild("tabStrip", {static: true}) tabStrip: TabStripComponent;

    ngOnInit() {
        const keyToNavText: Record<string, string> = {
            powerApps: 'PowerApps',
            approvals: 'Approvals',
            httpRequest: 'HTTP Request',
        };
        const applyDeprecatedTools = (visible: string[]) => {
            for (const [key, text] of Object.entries(keyToNavText)) {
                const item = this.nav.find(n => n.text === text);
                if (item) { item.hidden = !visible.includes(key); }
            }
        };
        this.storageDexieService.getConfig(Settings.SETTING_DEPRECATED_TOOLS_VISIBLE).then(v => {
            if (Array.isArray(v?.value)) {
                this.storageDexieService.deprecatedToolsVisible$.next(v.value);
            }
        }).catch(() => {});
        this.subscriptions.push(
            this.storageDexieService.deprecatedToolsVisible$.subscribe(visible => applyDeprecatedTools(visible))
        );

        this.subscriptions.push(this.flowEventService.openTabWindow$.subscribe((e:FlowEvent)=>{

            //e.value = true;

            let title = "";
            let item = null;
            let id = null;
            switch(e.type){
                case "app-flow-runs": title = "Runs"; break;
                case "app-flow-detail": title = e.value == "Flow" ? "Flow" : "Flow (Advanced)"; break;
                case "app-flow-diff": title = "Diff"; break;
                case "app-connector-detail": title = "Connector"; break;
                case "app-connection-detail": title = "Connection"; break;
                case "app-plan-edit": title = "Migration Plans"; break;
                case "app-plan": title = "Export Plan"; break;
            }

            item = (e.flow || e.connection || e.value);
            id = item.flowName || item.name;
            if (item.displayName) {
                title = `${title}: ${ item.displayName}`;
            }

            this.tabs = [
                ...this.tabs.filter(tab => !(tab.id == id && tab.type == e.type)),
                {
                    title: title,
                    type: e.type,
                    item: item,
                    id: id,
                    value: e.value
                }
            ];
            this.scheduleSelectedTab(this.tabs.findIndex(tab => tab.id == id && tab.type == e.type) + 1);

        }));

        this.subscriptions.push(this.flowEventService.closeTabWindow$.subscribe((e:FlowEvent)=>{

            e.value = true;

            let id = null;

            let item : any = e.flow || e.connection || {};
            id = e.id || item.flowName || item.name;

            this.tabs = this.tabs.filter(tab=>!(tab.id == id && tab.type == e.type));
            this.scheduleSelectedTab(0);

        }));
    }

    ngOnDestroy() {
        this.clearScheduledSelection();
        this.subscriptions.forEach( (subscription: Subscription)=>{
            subscription.unsubscribe();
        })
    }

    private scheduleSelectedTab(index: number): void {
        this.clearScheduledSelection();

        this.selectionTimeoutId = setTimeout(() => {
            this.selectedTabIndex = Math.max(0, Math.min(index, this.tabs.length));
            this.selectionTimeoutId = null;
        });
    }

    private clearScheduledSelection(): void {
        if (this.selectionTimeoutId !== null) {
            clearTimeout(this.selectionTimeoutId);
            this.selectionTimeoutId = null;
        }
    }

    trackTab(index: number, tab: { type: string, id: number }): string {
        return `${tab.type}:${tab.id ?? index}`;
    }

    public async onNavSelect(item: any) {
        if (item?.disabled) {
            return;
        }
        if (item.root === true) {
            this.expanded = !this.expanded;
            return;
        }
        if (item.internal === 'Feedback') {
            this.flowEventService.showFeedback$.emit();
            return;
        }
        const result = await this.router.navigate([item.url], {relativeTo: this.route})
        if (!result) {

            // try to deselect drawer but can't get it to work.

            // const nav_item = this.nav.find((item) => this.router.url.startsWith(item.url));
            // if (nav_item) {
            //     console.log(nav_item);
            //     setTimeout(()=>{
            //         nav_item.selected = true;
            //     },1);
            // }

        }
    }

    isSelected(item: any): boolean {
        if (!item?.url) {
            return false;
        }
        const url = (this.router.url || '').split('?')[0].split('#')[0];
        if (item.matchPrefix) {
            return url === item.url || url.startsWith(`${item.url}/`);
        }
        return url === item.url;
    }

    private findBestNavMatch(url: string): any {
        return [...this.nav]
            .filter((item) => item?.url && url.startsWith(item.url))
            .sort((a, b) => (b.url?.length || 0) - (a.url?.length || 0))[0];
    }

    get visibleNav(): any[] {
        return this.nav.filter(item => !item.hidden);
    }

    get sidebarPrimaryNav(): any[] {
        return this.visibleNav.slice(1).filter(item => !item.separator && item.text !== 'Settings' && !this.isGroupedItem(item));
    }

    get sidebarDiscoverParent(): any {
        return { text: 'DISCOVER' };
    }

    get sidebarDiscoverChildren(): any[] {
        return this.visibleNav.slice(1).filter(item => ['Admin Flows', 'Search', 'Approvals', 'Connections', 'HTTP Request', 'Child Flows'].includes(item.text));
    }

    get sidebarBuildParent(): any {
        return { text: 'BUILD' };
    }

    get sidebarBuildChildren(): any[] {
        return this.visibleNav.slice(1).filter(item => ['Migrate Flows', 'Compare Flows', 'Export Flows'].includes(item.text));
    }

    get sidebarWorkspaceNav(): any[] {
        return this.visibleNav.slice(1).filter(item => item.team === true);
    }

    get sidebarFooterNav(): any[] {
        return this.visibleNav.slice(1).filter(item => item.text === 'Settings');
    }

    private isGroupedItem(item: any): boolean {
        return item?.team === true || ['Admin Flows', 'Search', 'Approvals', 'Connections', 'Migrate Flows', 'Compare Flows', 'Export Flows', 'HTTP Request', 'Child Flows'].includes(item?.text);
    }

    get routeName(): string {
        if (this.router.url == '/success') {
            return 'Governance';
        }
        if (this.router.url == '/deploy'){
            return 'Deploy';
        }
        if (this.router.url == '/admin') {
            return 'Admin';
        }
        if (this.router.url == '/flows/actions') {
            return 'Flows/Actions'
        }
        return this.nav.filter(n=> n.url == this.router.url).map(n=>n.text)[0];
    }

    public onTabSelect(e) {
        this.selectedTabIndex = e.index;

//         let tab = this.tabs.find(tab=>tab.title == e.title);

//         if (tab && tab.title == "Migrate") {
// debugger
//         }
    }

    public onTabClose(e:TabCloseEvent) {

        this.tabs = this.tabs.filter((tab, index)=>index != (e.index-1) );
        this.scheduleSelectedTab(e.index - 1);

    }
}






